import { createSelector } from '@reduxjs/toolkit'

export const facetEntities = state => state.currentPage.facets
export const productEntities = state => state.currentPage.products
export const subCategoryEntities = state => state.currentPage.subCategories

export const categoryNavigationEntities = state => state.currentPage.categoryNavigation

export const currentPageSelector = state => state.currentPage
export const breadcrumbEntities = state => state.currentPage.categoryBreadcrumb
export const displayCategoryBreadcrumb = state => state.currentPage.displayCategoryBreadcrumb

export const maxPrice = state => state.currentPage.priceStats.maxPrice
export const minPrice = state => state.currentPage.priceStats.minPrice
export const priceRange = state => state.currentPage.priceStats.range

const pageLoading = state => state.currentPage.loading
const pageFilteringContext = state => state.currentPage.pagingFilteringContext

export const productsSelector = createSelector(
	productEntities,
	pageLoading,
	(products, isLoadingProducts = false) => ({ products, isLoadingProducts }),
)

export const minMaxPriceSelector = createSelector(
	maxPrice,
	minPrice,
	priceRange,
	(max, min, range) => ({ max, min, range }),
)

export const pagingFilteringContextSelector = createSelector(
	pageFilteringContext,
	({ pageSizeOptions, availableSortOptions, pageSize }) => ({
		pageSizeOptions,
		availableSortOptions,
		pageSize,
	}),
)
